// Preferences.jsx
import { Form, Button } from "react-bootstrap";

export default function Preferences() {
  return (
    <>
      <h5 className="mb-3">Preferences</h5>

      <div className="section-border">
        <h6>System Preferences</h6>

        <Form.Check label="Enable Notifications" className="mb-2" />
        <Form.Check label="Enable Auto Backup" className="mb-2" />
        <Form.Check label="Enable Email Alerts" />
      </div>

      <div className="text-end">
        <Button variant="light">Cancel</Button>
        <Button className="btn-orange ms-2">Save</Button>
      </div>
    </>
  );
}